<!--护士-->
<template>
	<div style="position:relative">
		<div class="alarm-item-con" style=" min-width:1200px;" @click="lightBoxClick">
			<div v-if="isShowSearchCom">
				<SearchCop @searchRoom="searchRoom"></SearchCop>
			</div>
			<div v-else class="seach-text">
				关于“{{ seachText }}”共搜索到
				<span class="seach-text-height">{{ roomList ? roomList.length : '0' }}</span> 条结果
				<span class="seach-text-height seach-text-hover" @click="backList">返回</span>
			</div>
			<div class="contant">
				<div v-for="(item, index) in (roomList || [])" :key="index" @click="toDetailPage(item)">
					<BedItem :roomData="item"></BedItem>
				</div>
			</div>
			<div v-if="isShowDialog && this.role != 2">
				<Dialog ref="dialog" @closeDialog="closeDialog" :dialogData="dialogData"></Dialog>
			</div>
		</div>
		<!-- <div class="aaaa" v-if="AlarmTone && role == '3'">
			<p>系统将会开启报警音</p>
			<a-button type="primary" @click="aaaa">确定</a-button>
		</div> -->
		<div class="real-time-bg">
			<div class="bg-left"></div>
			<div class="bg-right"></div>
		</div>
	</div>
</template>

<script>
//引用文件
import mp3 from '../../assets/video/sound_Alarm.mp3';
import BedItem from './compoent/bedItem.vue';
import Dialog from './compoent/dialog.vue';
import SearchCop from './compoent/searchCop.vue';

export default {
	components: {
		BedItem,
		SearchCop,
		Dialog,
	},
	data() {
		return {
			role: 2,
			tenantId: null,
			isShowSearchCom: true,
			seachText: '',
			isShowDialog: false,
			roomList: [],
			dialogData: [],
			socketStatus: null,
			stompClientStatus: null,
			socketStatusAlarm: null,
			stompClientStatusAlarm: null,
			reconInv: null,
			reconInvAlarm: null,
			AlarmTone: true,
			lightBox: false,
			audio: null,
			alarmFlag: false,
			alalrmInterval: null,
			alalrmTimeOut: null,
			speakMsg: null,
			bedIdArr: [],

			nowPageTime: 0,       //当前页面时间，用于计时
			action: 1,
			isFirstIn: true,
			searchFloor: '',
			searchLayer: '',
			searchText: '',
			isRequest: false
		};
	},
	created() {
		this.tenantId = this.$getCookie('userInfo').user.tenantId;
		this.role = this.$getCookie('userInfo').user.roleId;
		console.log(this.dialogData);
		this.dialogData = [];

	},
	mounted() {
		this.searchRoom('', '', '', false, false);
		this.searchAlarm(true);
		this.getSocketStatus();
		// this.getSocketStatusAlarm();
		this.listenPage();
		// let DomData = document.querySelectorAll('.ant-message-notice-content');
		// DomData[0].style.opacity = '0';
		// console.log(DomData);
		if (this.role == '3') {
			let audio = document.getElementById('music');
			audio.volume = 0;
			// audio.play();
		}
		if (sessionStorage.getItem('aval')) {
			this.AlarmTone = false;
			if (this.role == '3') {
				setTimeout(() => {
					this.aaaa();
				}, 1000);
			}
		} else {
			sessionStorage.setItem('aval', 2);
			this.AlarmTone = true;
		}
		// this.timeRefresh();     //针对德龙机构计时刷新页面
	},
	methods: {
		// 针对德龙机构计时刷新页面
		// timeRefresh() {
		// 	let tenantId = this.$getCookie('userInfo').user.tenantId;
		// 	console.log('当前tenantId为' + tenantId)
		// 	// if(tenantId == 59 || tenantId == 119){
		// 	let timeRefName = setInterval((res) => {
		// 		this.nowPageTime += 1
		// 		console.log('正在计时...' + this.nowPageTime)
		// 		let nowPageRouter = this.$route.path;
		// 		// if(this.nowPageTime == 10){       //若计时半小时了
		// 		if (this.nowPageTime == 1800) {       //若计时半小时了
		// 			if (nowPageRouter == '/protect/home') {
		// 				this.$router.go(0);
		// 			}
		// 		}
		// 	}, 1000)
		// 	// 通过 $once 来监听定时器，在 beforeDestroy 钩子可以被清除。
		// 	this.$once('hook:beforeDestroy', () => {
		// 		if (timeRefName) {
		// 			clearInterval(timeRefName);
		// 		}
		// 		timeRefName = null;
		// 	})
		// 	// }
		// },
		dddd(str) {
			if (this.role != '3') {
				return
			}
			let newstr = str.split('').join(' ');
			this.speakMsg = new SpeechSynthesisUtterance(newstr);
			this.speakMsg.rate = 1; // 语速
			this.speakMsg.lang = 'zh';
			this.speakMsg.pitch = 0.5; // 音量
			window.speechSynthesis.speak(this.speakMsg);
			// 兼容语音播报
			// var url =
			//   'https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&rate=32&per=0&tex=' +
			//   encodeURI(newstr); // baidu文字转语音
			// var audio = new Audio(url);
			// audio.src = url;
			// audio.play();
		},
		//停止音频
		stopAudio(data) {
			// let audio = document.getElementById('music');
			// audio.volume = 0;
			// audio.pause();
			// window.speechSynthesis.cancel()
			// for (let index = 0; index < 1000000; index++) {
			//	 clearInterval(index);
			// }
			if (data === 1) {
				this.GoHandle();
			}
			setTimeout(() => {
				this.$message.destroy();
			}, 1000);
			// this.timeRefresh();     //针对德龙机构计时刷新页面
		},
		GoHandle(e) {
			this.speakMsg = null;
			this.speakMsg ? (this.speakMsg.pitch = 0) : null; // 音量
			if (this.alalrmInterval) {
				clearInterval(this.alalrmInterval);
			}
			if (this.alalrmTimeOut) {
				clearTimeout(this.alalrmTimeOut);
			}
			this.alalrmInterval = null;
			this.alalrmTimeOut = null;
			for (let index = 0; index < 100; index++) {
				clearInterval(index);
				clearTimeout(index);
			}
			let params = {}
			let alarmEventList = [];
			this.dialogData.forEach((item) => {
				alarmEventList.push(
					{
						bedId: item.bedId,
						radarType: item.radarType
					}
				);
			});
			params.alarmEventList = alarmEventList;
			params.action = this.action;
			this.$post(
				'/api/event/batchEventProc',
				params,
				(res) => {
					console.log('===dialogData===', this.dialogData)
					let tempData = JSON.parse(JSON.stringify(this.dialogData)) || [];
					for (let i = 0; i < tempData.length; i++) {
						tempData[i].status = 6;
					}
					this.dialogData = tempData;
					if (this.alalrmInterval) {
						clearInterval(this.alalrmInterval);
						this.alalrmInterval = null;
					}
					let audio = document.getElementById('music');
					audio.volume = 0;
					audio.pause();
					window.speechSynthesis.cancel()
				},
				(err) => {
					//console.log(err);
				}
			);
			// this.timeRefresh();     //针对德龙机构计时刷新页面
		},
		lightBoxClick() {
			this.action = 1;
			this.stopAudio(1);
		},
		aaaa() {
			if (this.role != '3') {
				return
			}
			this.stopAudio();
			this.AlarmTone = false;
			if (this.alalrmInterval) {
				clearInterval(this.alalrmInterval);
				this.alalrmInterval = null;
			}
			let audio = document.getElementById('music');
			audio.volume = 0;
			audio.pause();
			window.speechSynthesis.pause();
			window.speechSynthesis.resume();
			window.speechSynthesis.cancel()
			if (this.role == '3') {
				let str = this.getAlarmStr();
				if (str.length > 0) {
					let times = Math.ceil(str.length / 3) * 1000 + 3000;
					// console.log('===str===', str, str.length, times)
					this.alalrm(str);
					this.alalrmInterval = setInterval(() => {
						this.aaaa();
					}, times);
				} else {
					this.GoHandle();
				}
			}
		},
		getAlarmStr() {
			let str = '';
			console.log(this.dialogData, 'this.dialogDatathis.dialogData');
			if (this.dialogData && this.dialogData.length > 0) {
				this.dialogData.forEach((item) => {
					if (item.status === 5) {
						if (item.statusName == '需要帮助') {
							str += item.roomName + item.bedName + item.statusName;
						} else {
							str += item.roomName;
						}
					}
				});
			}
			return str;
		},
		alalrm(str) {
			let audio = document.getElementById('music');
			audio.play();
			audio.volume = 1;
			this.alalrmTimeOut = setTimeout(() => {
				this.dddd(str);
			}, 2200);
		},
		listenPage() {
			window.onbeforeunload = function (e) {
				sessionStorage.removeItem('aval');
			};
		},
		searchAlarm(isAlarm = false) {
			if (this.role == 2) {
				return;
			}
			this.$get(
				'/api/v3/bed/getBedAlarmList',			//报警列表
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							let isUpdateDialogData = false
							if (res.data.length != this.dialogData.length) {
								isUpdateDialogData = true
							} else {
								for (let i = 0; i < this.dialogData.length; i++) {
									let tempItem1 = this.dialogData[i];
									let tempItem2 = res.data[i];
									if (tempItem1.bedId != tempItem2.bedId || tempItem1.status != tempItem2.status || tempItem1.subStatus != tempItem2.subStatus || tempItem1.radarType != tempItem2.radarType || tempItem1.hasAlarm != tempItem2.hasAlarm || tempItem1.roomId != tempItem2.roomId) {
										isUpdateDialogData = true
									}
								}
							}
							if (isUpdateDialogData) {
								this.dialogData = [];
								this.dialogData = res.data;
							}
							this.tenantId = this.$getCookie('userInfo').user.tenantId;
							this.role = this.$getCookie('userInfo').user.roleId;
							if (this.role == '3' && isAlarm) {			//护工
								this.aaaa();
							}
							if (res.data.length === 0) {
								this.isShowDialog = false;
								this.stopAudio();
							} else {
								if (isUpdateDialogData) {
									this.dialogData = [];
									this.dialogData = res.data;
								}
								if (this.isFirstIn) {
									this.isShowDialog = true;
									this.isFirstIn = false;
								} else {
									res.data.forEach((item) => {
										if (item.status == 5) {
											this.isShowDialog = true;
										}
									});
								}
							}
							if (isUpdateDialogData) {
								setTimeout(() => {
									this.$refs.dialog
										? this.$refs.dialog.changeArray(this.dialogData, 3)
										: null;
								}, 1000);
							}
						}
					} else {
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error('服务端发生异常');
				}
			);
		},
		changeDomHeight() {
			let domroomList = document.querySelectorAll('.equipment-con');
			let listHight = [];
			let domHeight = null;
			for (let i = 0; i < domroomList.length; i++) {
				listHight.push(domroomList[i].clientHeight);
			}
			console.log(listHight);
			domHeight = Math.max(...listHight);
			for (let i = 0; i < domroomList.length; i++) {
				domroomList[i].style.height = domHeight + 'px';
			}
			let domroomList2 = document.querySelectorAll('.title-room');
			let listHight2 = [];
			let domHeight2 = null;
			for (let i = 0; i < domroomList2.length; i++) {
				listHight2.push(domroomList2[i].clientHeight);
			}
			console.log(listHight2);
			domHeight2 = Math.max(...listHight2);
			for (let i = 0; i < domroomList2.length; i++) {
				domroomList2[i].style.height = domHeight2 + 'px';
			}
		},
		searchRoom(floor = '', layer = '', text = '', isClick = false, isKeepSelect = false) {
			if (this.isRequest) {
				return
			}
			this.isRequest = true;
			if (isKeepSelect) {
				floor = this.searchFloor;
				layer = this.searchLayer;
				text = this.seachText;
			} else {
				this.searchFloor = floor;
				this.searchLayer = layer;
				this.seachText = text;
			}
			console.log(floor, layer, text);
			let params = {
				buildingId: floor,
				floorId: layer,
				search: text,
			};
			this.$get(
				'/api/v3/bed/showList',
				params,
				(res) => {
					this.isRequest = false;
					if (res.code == 0) {
						if (res.data) {
							// 旧版本
							// this.roomList = res.data;
							// if (res.data.length > 0) {
							// 	res.data.forEach((item) => {
							// 		if (item && item.bedList) {
							// 			item.bedList.forEach((jtem) => {
							// 				this.bedIdArr.push(jtem.bedId);
							// 			});
							// 		}
							// 	});
							// }

							// 新版本 处理数据
							if (res.data && res.data.length > 0) {
								for (let i = 0; i < res.data.length; i++) {
									res.data[i].bedList = [];
									if (res.data[i] && res.data[i].bedListMap) {
										let object = res.data[i].bedListMap;
										for (const key in object) {
											if (Object.hasOwnProperty.call(object, key)) {
												let elements = object[key] || [];
												let addItem = {};
												for (let k = 0; k < elements.length; k++) {
													let elementItem = elements[k];
													if (elementItem.radarType != 3) {
														addItem = elementItem;
													} else {
														addItem.sosSubStatus = elementItem.subStatus;
														addItem.sosStatusName = elementItem.statusName;
														addItem.sosHasAlarm = elementItem.hasAlarm;
														addItem.bedName = elementItem.bedName;
														addItem.bedId = elementItem.bedId;
													}
												}
												res.data[i].bedList.push(addItem);
											}
                                        }
									}
								}
							}
							this.roomList = res.data;
							if (res.data.length > 0) {
								res.data.forEach((item) => {
									if (item && item.bedList) {
										item.bedList.forEach((jtem) => {
											this.bedIdArr.push(jtem.bedId);
										});
									}
								});
							}

							if (isClick) {
								this.isShowSearchCom = false;
							} else {
								this.isShowSearchCom = true;
							}

							setTimeout(() => {
								this.changeDomHeight();
							}, 100);
						} else {
						}
					} else {
					}
				},
				(err) => {
					this.isRequest = false;
					//console.log(err);
					// // this.$message.error('服务端发生异常');
				}
			);
		},
		backList() {
			this.searchRoom('', '', '', false, false);
		},
		closeDialog() {
			this.isShowDialog = false;
			this.action = 2;
			this.stopAudio(1);
		},
		toDetailPage(data) {
			console.log(data);
			if (this.role == '3') {
				this.$router.push({
					path: '/protect/realTimeMonitoringtwo/?roomId=' + data.roomId,
				});
			} else if (this.role == '2') {
				this.$router.push({
					path: '/dean/realTimeMonitoringtwo/?roomId=' + data.roomId,
				});
			}
		},
		getSocketStatus() {
			var that = this;
			let id = this.tenantId;
			let flag = 0;
			var wsUrl = this.$store.state.baseUrl + '/api/ws/event';
			if (wsUrl.indexOf('http://') === 0) {
				wsUrl = wsUrl.replace('http://', 'ws://');
			} else if (wsUrl.indexOf('https://') === 0) {
				wsUrl = wsUrl.replace('https://', 'wss://');
			} else {
				wsUrl = wsUrl;
			}
			this.socketStatus = new WebSocket(wsUrl); // 路径
			this.stompClientStatus = Stomp.over(this.socketStatus);
			this.stompClientStatus.debug = null;
			let headers = {
				Authentication: this.$getCookie('userInfo').token, // 获取token
			};
			// 连接
			console.log('Websocket - allRoomStatus - 开始重连 - 1');
			this.stompClientStatus.connect(
				headers,
				(frame) => {
					this.stompClientStatus.subscribe(
						'/topic/allRoomStatus.' + id,
						(greeting) => {
							if (greeting && greeting.body) {
								if (this.$route.path == '/dean/realTimeMonitoringtwo/') {
									return;
								}
								console.log('Websocket - allRoomStatus - 收到消息 - 2');
								let socketData = JSON.parse(greeting.body);
								this.searchRoom('', '', '', false, true);    //页面列表查询
								this.searchAlarm()    //报警列表查询
								// 设备报警
								if (socketData && socketData.bedList) {
									socketData.bedList.forEach((item) => {
										if (item.status === 5) {      //报警
											this.searchAlarm(true);
										}
									})
								}
								// 设备自动解除报警
								if (this.dialogData && socketData) {
									this.dialogData.forEach((item) => {
										if (socketData.bedList) {
											socketData.bedList.forEach((jtem) => {
												if (item.bedId === jtem.bedId) {
													if (jtem.status !== 5) {
														// this.searchAlarm(true);
													}
												}
											});
										}
									});
								}
							}
						}
					);
				},
				(err) => {
					// console.log('Websocket失败 - allRoomStatus - 即将重连 - 3');
					// this.reconnect();
					// if (this.stompClientStatus) {
					// 	this.stompClientStatus.close();
					// 	this.stompClientStatus = null;
					// }
					// this.getSocketStatus();
				}
			);
			this.socketStatus.onclose = function(e) {
				console.log('Websocket失败 - allRoomStatus - 即将重连 - 3 - onclose');
				that.getSocketStatus();
			};
			this.socketStatus.onerror = function(e) {
				console.log('Websocket失败 - allRoomStatus - 即将重连 - 3 - onerror');
				that.getSocketStatus();
			};
		},

		getSocketStatusAlarm() {
			var that = this;
			let id = this.tenantId;
			var wsUrl = this.$store.state.baseUrl + '/api/ws/event';
			if (wsUrl.indexOf('http://') === 0) {
				wsUrl = wsUrl.replace('http://', 'ws://');
			} else if (wsUrl.indexOf('https://') === 0) {
				wsUrl = wsUrl.replace('https://', 'wss://');
			} else {
				wsUrl = wsUrl;
			}
			this.socketStatusAlarm = new WebSocket(wsUrl); // 路径
			this.stompClientStatusAlarm = Stomp.over(this.socketStatusAlarm);
			this.stompClientStatusAlarm.debug = null;
			let headers = {
				Authentication: this.$getCookie('userInfo').token, // 获取token
			};
			// 连接
			console.log('Websocket - alarmBed - 开始重连 - 1');
			this.stompClientStatusAlarm.connect(
				headers,
				(frame) => {
					this.stompClientStatusAlarm.subscribe(
						'/topic/alarmBed.' + id,
						(greeting) => {
							console.log('Websocket - alarmBed - 收到消息 - 2');
							if (greeting && greeting.body) {
								let socketData = JSON.parse(greeting.body);
								if (this.bedIdArr.includes(socketData.bedId)) {
									if (this.role != 2) {
										this.$router.push({
											path: '/protect/home',
										});
									}
								}
							}
						}
					);
				},
				(err) => {
					// console.log('Websocket失败 - alarmBed - 即将重连 - 3');
					// this.reconnectAlalm();
					// if (this.stompClientStatusAlarm) {
					// 	this.stompClientStatusAlarm.close();
					// 	this.stompClientStatusAlarm = null;
					// }
					// this.getSocketStatus();
				}
			);
			this.socketStatusAlarm.onclose = function(e) {
				console.log('Websocket失败 - alarmBed - 即将重连 - 3 - onclose');
				that.getSocketStatusAlarm();
			};
			this.socketStatusAlarm.onerror = function(e) {
				console.log('Websocket失败 - alarmBed - 即将重连 - 3 - onerror');
				that.getSocketStatusAlarm();
			};
		},
		reconnect() {
			if (this.reconInv) {
				clearInterval(this.reconInv);
			}
			this.reconInv = setTimeout(() => {
				this.getSocketStatus();
			}, 2000);
		},
		reconnectAlalm() {
			if (this.reconInvAlarm) {
				clearInterval(this.reconInvAlarm);
			}
			this.reconInvAlarm = setTimeout(() => {
				this.getSocketStatusAlarm();
			}, 2000);
		},
	},
	beforeDestroy() {

	},
};
</script>
<style lang="scss" scoped>
.real-time-bg {
	width: 100%;
	height: 100%;
	position: absolute;
	top: -15px;
	left: 0;
	z-index: 0;
	display: flex;
	justify-content: space-between;

	.bg-left {
		width: 500px;
		height: 570px;
		background: url('./../../assets/img/leftFlower@2x.png') no-repeat center;
		background-size: contain;
	}

	.bg-right {
		width: 500px;
		height: 570px;
		background: url('./../../assets/img/rightFlower@2x.png') no-repeat center;
		background-size: contain;
	}
}

.alarm-item-con {
	width: 80%;
	margin: 0 auto;
	position: relative;
	z-index: 1;

	.seach-text {
		margin: 35px 0 20px 40px;
	}

	.seach-text-height {
		color: #1890ff;
	}

	.seach-text-hover {
		cursor: pointer;
	}
}

.aaaa {
	width: 200px;
	line-height: 50px;
	text-align: center;
	background: #ffffff;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 20000;
	// z-index: -1000;
	border-radius: 4px;
	box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);

	p {
		margin-bottom: 0;
	}
}

.contant {
	display: flex;
	margin-bottom: 16px;
	flex-wrap: wrap;
}
</style>
